import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import emitter, { Events } from '@/event';
import { i18n } from '../helpers/i18n';

let language = 'da-DK';

const factory = {
    setLanguage: (lang: string) => {
        language = lang;
    },
    create: async (config?: AxiosRequestConfig) => {
        config = config || {};

        const client = axios.create(config);

        // Default settings for request
        client.interceptors.request.use((config) => {
            config.headers['Accept-Language'] = language;

            return config;
        });

        client.interceptors.response.use(
            (response) => response,
            (error) => {
                const t = i18n.t;

                if (error.response.data.title == 'RequestTimeout')
                    emitter.emit(Events.AddNotification, t('general.$error') + ': ' + t('general.error.$requestTimeout'));
                else if (error.response.data.title == 'BrokenCircuit')
                    emitter.emit(Events.AddNotification, t('general.$error') + ': ' + t('general.error.$brokenCircuit'));
                else if (error.response.data.title == 'RequestError')
                    emitter.emit(Events.AddNotification, t('general.$error') + ': ' + t('general.error.$requestError'));
                else if (error.response.data.title == 'RequestCanceled')
                    emitter.emit(Events.AddNotification, t('general.$error') + ': ' + t('general.error.$requestCanceled'));

                /* Todo: Remove this else if clause as the specific error should be handled in the specific .vue files calling dependencies
                Make sure to ensure that errors are handled everywhere before deleting this else if clause*/ 
                else if (error.response.status != 401)
                    emitter.emit(Events.AddNotification, t('general.$error') + ': ' + error.message);

                if (error.response && error.response.status == 401) {
                    // We are not logged in anymore, or the DataBroker authentication has expired.
                    emitter.emit(Events.LoggedOut);
                }
                return Promise.reject(error);
            }
        );

        return client;
    }
};

export default factory;
